<script setup>
import {ref} from "vue";
import {appUpdateRegistration} from "@/tools/appUpdate";

const updating = ref(false);

function updateHandler() {
    const registration = appUpdateRegistration.value;
    if (!registration?.waiting || updating.value) {
        return;
    }
    updating.value = true;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload();
    }, {once: true});
    registration.waiting.postMessage({type: 'SKIP_WAITING'});
}
</script>

<template>
  <div
      v-if="appUpdateRegistration"
      class="appUpdateNotice"
      role="alert"
      @click="updateHandler"
  >
    <span class="appUpdateNotice__text">Доступна новая версия приложения. Нажмите, чтобы обновить.</span>
  </div>
</template>

<style scoped lang="scss">
.appUpdateNotice {
  position: fixed;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1100;
  max-width: calc(100vw - 32px);
  padding: 12px 16px;
  border-radius: 12px;
  background-color: #17a2b8;
  color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  text-align: center;

  &__text {
    font-size: 14px;
    line-height: 1.4;
  }
}
</style>
